import { Component } from '@angular/core';

@Component({
  selector: 'doctor-gui-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'zdb-admin-panel';
}
